module.exports = __webpack_public_path__ + "media/images/flags/64/Cote-dIvoire-db39e8d428b394bd64ddd1dab0a3f6af.png";